<div class="specification-display">
  <div class="flex align-middle gap-4">
    <div class="col-md-6 border-r-2">
      <div class="specification-item">
        <label class="specification-label">Client Part #</label>
        <div class="specification-value">
          {{ details.clientPartNo }}
        </div>
      </div>

      <div class="specification-item">
        <label class="specification-label">AWG</label>
        <div class="specification-value">{{ getDetailValue('awg') }}</div>
      </div>

      <div class="specification-item">
        <label class="specification-label">Wire Type</label>
        <div class="specification-value">{{ getDetailValue('wireType') }}</div>
      </div>

      <div class="specification-item">
        <label class="specification-label">Finished Diameter</label>
        <div class="specification-value">{{ getDetailValue('finishedDiameter') }}</div>
      </div>

      <div class="specification-item">
        <label class="specification-label">Die</label>
        <div class="specification-value">{{ getDetailValue('die') }}</div>
      </div>

      <div class="specification-item">
        <label class="specification-label">Jacket Material</label>
        <div class="specification-value">{{ getDetailValue('jacketMaterial') }}</div>
      </div>

      <div class="specification-item">
        <label class="specification-label">Jacket Printing</label>
        <div class="specification-value">{{ getDetailValue('jacketPrinting') }}</div>
      </div>

      <div class="specification-item">
        <label class="specification-label">Inner Diameter</label>
        <div class="specification-value">{{ getDetailValue('innerDiameter') }}</div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="specification-item">
        <label class="specification-label">Stranding</label>
        <div class="specification-value">{{ getDetailValue('stranding') }}</div>
      </div>

      <div class="specification-item">
        <label class="specification-label">Finished Diameter</label>
        <div class="specification-value">{{ getDetailValue('finishedDiameter') }}</div>
      </div>

      <div class="specification-item">
        <label class="specification-label">Tip</label>
        <div class="specification-value">{{ getDetailValue('tip') }}</div>
      </div>

      <div class="specification-item">
        <label class="specification-label">Put Up</label>
        <div class="specification-value">{{ getDetailValue('putUp') }}</div>
      </div>

      <div class="specification-item">
        <label class="specification-label">Jacket Color</label>
        <div class="specification-value">{{ getDetailValue('jacketColor') }}</div>
      </div>

      <div class="specification-item">
        <label class="specification-label">Wall Thickness</label>
        <div class="specification-value">{{ getDetailValue('wallThickness') }}</div>
      </div>

      <div class="specification-item">
        <label class="specification-label">Outer Diameter</label>
        <div class="specification-value">{{ getDetailValue('outerDiameter') }}</div>
      </div>
    </div>
  </div>
</div>
